import { render, staticRenderFns } from "./UploadPicSort.vue?vue&type=template&id=519bd072&scoped=true"
import script from "./UploadPicSort.vue?vue&type=script&lang=js"
export * from "./UploadPicSort.vue?vue&type=script&lang=js"
import style0 from "./UploadPicSort.vue?vue&type=style&index=0&id=519bd072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bd072",
  null
  
)

export default component.exports